// 引入axios
import axios from 'axios'
import router from '../router'
// import router from 'vue-router'
import {getItem} from "./localStorage.js"

// import store from '@/store'
import { Message } from 'element-ui'
import configa from "@/utils/config.js"
const baseURL = configa.baseUrl



const request = axios.create({
  baseURL: baseURL,
  timeout: 10000000, //请求超时
})
// request.baseURL = baseURL

// 请求拦截器
request.interceptors.request.use(

  // config : 本次请求的配置对象
  // config : 里面有一个属性: headers
  // const { userToken } = store.state
  function (config) {
    const token = getItem('user_token');
    const id = getItem('user_id');
	// 有用户请求头加用户的token
	if(token){
		config.headers.token =token;
		config.headers.id =id;
	}
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
let t=this
// 响应拦截器
request.interceptors.response.use(
  response => {
    const res = response.data
	console.log(res)
		// 202表示没有token
		// if(res.code == 202){  // 如果请求失败，则给一个提示 并返回登录页
		// 	Message({
		// 	  message:'请重新登录',
		// 	  // icon:'none',
		// 	  type: 'error',
		// 	  // duration: 2 * 1000
		// 	})
		// 	router.push('/login')
		// 	return Promise.reject(error) ;
		// }
		// 用箭头函数，res是返回来的数据
		if(res.code !==200){
				// router.push('/null')
			Message({
			  message: res.msg || 'Error',
			  type: 'error',
			  duration: 2 * 1000
			})
			return Promise.reject(res)
		}else{
			return res
		}
  },
  error => {
    Message({
      message: error.msg || 'Error',
      type: 'error',
      duration: 2 * 1000
    })
    return Promise.reject(error)
  }
)

export default request
